<script>
export const pageName = 'records-type';
export const pageRoute = '/records/{type}';
export const title = 'Altitude Records'
export const requireAuth = false

import { recordTypeToEnglish } from '../../../functions/domain/certification-utils.js';
import { listenToRecordsHallOfFame } from '../../js/readModel.js'
import CertFlightCardUrl from '../../resources/Cert-and-Record-flight-card-A4-v3-1.pdf'


export default {
	data() {
		return {
			type: null,
			hallOfFame: null,
			classKeys: [],
			showHistory: {},
			CertFlightCardUrl,
			ready: false
		}
	},

	methods: {
		async boot(opts) {
			this.type = recordTypeToEnglish(opts.type);
			await listenToRecordsHallOfFame(opts.type, hallOfFame => {
				this.hallOfFame = hallOfFame;
				this.classKeys =  Object.keys(hallOfFame.classes).sort()
				this.showHistory = Object.keys(hallOfFame.classes).reduce((p, c) => {
					p[c] = false;
					return p;
				},  {})
			});
			this.ready = true;
		},
		setHistoryForClass(recordClass, show)
		{
			this.showHistory[recordClass] = show
		}
	}
}

</script>
<template>
	<div v-if="ready" class="container py-5">
		<h1 class="display-4 text-center mb-3">Altitude Records: {{ type }}</h1>
		<p class="text-muted text-center mb-3">Altitude records are the highest altitudes achieved by UKRA members past and present.</p>
		<p class="text-muted text-center mb-3">Come within 15% of a record to get onto the table, or break the record to take the lead!</p>
		<p class="text-muted text-center mb-3">Gain 50 XP in <a href="/model-achievement-programme">MAP</a> for a new record and 10 XP for coming within 15% or claiming a vacant record.</p>
		<p class="text-muted text-center mb-3">See <a href="https://ukra.org.uk/info/records" target="_blank">the main UKRA website <span class="fe fe-external-link"></span></a> for a full description of the rules and how to submit an attempt.</p>
		<p class="text-muted text-center mb-5">Download the <a :href="CertFlightCardUrl" target="_blank">Flight Card <span class="fe fe-download"></span></a> for use in the field.</p>

		<div class="row justify-content-center">
			<div class="col-12 col-lg-8">
				<div v-for="key of classKeys" class="card">
					<div class="card-header">
						<h4 class="card-header-title">{{ key }} class</h4>
					</div>
					<div class="card-body">
						<div v-if="hallOfFame.classes[key].currentRecord" class="row align-items-center">
							<div class="col-auto">
								<div class="avatar avatar-xl">
									<img class="avatar-img rounded-circle" :src="hallOfFame.classes[key].currentRecord.userAvatar">
								</div>
							</div>
							<div class="col">
								
								<h4 v-if="hallOfFame.classes[key].currentRecord.teamName" class="mb-1">{{ hallOfFame.classes[key].currentRecord.teamName }}</h4>
								<h4 v-else class="mb-1">{{ hallOfFame.classes[key].currentRecord.userName }}</h4>
								<div class="small">{{ hallOfFame.classes[key].currentRecord.location }}</div>
								<div class="small">{{ hallOfFame.classes[key].currentRecord.flownOn.format('yyyy/MM/dd') }}</div>
							</div>
							<div class="col">
								<h4 class="mb-1">{{ hallOfFame.classes[key].currentRecord.altitude }}ft / {{ (hallOfFame.classes[key].currentRecord.altitude * 0.3048).toFixed(0) }}m AGL</h4>
								<div class="small">{{ hallOfFame.classes[key].currentRecord.altimeter }}</div>
								<div class="small">{{ hallOfFame.classes[key].currentRecord.rocketName }} - {{ hallOfFame.classes[key].currentRecord.rocketDiameter }}mm x {{ hallOfFame.classes[key].currentRecord.rocketMass }}g</div>
								<div class="small">{{ hallOfFame.classes[key].currentRecord.rocketMotors }}</div>
							</div>
						</div>
						<div v-else class="row align-items-center">
							<div class="col-auto">
								<div class="avatar avatar-xl">
									<div class="bg-primary-soft avatar-img rounded-circle">
									</div>
								</div>
							</div>
							<div class="col">
								<h4 class="mb-1">Vacant Record</h4>
								<div class="small">This record is not currently held</div>
								<div class="small"></div>
							</div>
							
							<div class="col">
								<h4 v-if="hallOfFame.classes[key].altitudeToBeat > 0" class="mb-1">{{ hallOfFame.classes[key].altitudeToBeat.toFixed(0) }}ft / {{ (hallOfFame.classes[key].altitudeToBeat * 0.3048).toFixed(0) }}m AGL takes the record</h4>
								<h4 v-else class="mb-1">Any altitude takes the record</h4>
								<div v-if="hallOfFame.classes[key].altitudeToBeat > 0" class="small">Come within 15% of the previous record</div>
								<div v-else class="small">There is no record to beat</div>
							</div>
						</div>
						<div v-if="showHistory[key]" v-for="(record, index) in hallOfFame.classes[key].history" :class="`row align-items-center border-top ${index == 0 ? 'mt-4' : ''} ${index < hallOfFame.classes[key].history.length - 1 ? 'py-4' : 'pt-4'}`">
							<div class="col-auto">
								<div class="avatar avatar-xl">
									<img class="avatar-img rounded-circle" :src="record.userAvatar">
								</div>
							</div>
							<div class="col">
								<h4 v-if="record.teamName" class="mb-1">{{ record.teamName }}</h4>
								<h4 v-else class="mb-1">{{ record.userName }}</h4>
								<div class="small">{{ record.location }}</div>
								<div class="small">{{ record.flownOn.format('yyyy/MM/dd') }}</div>
							</div>
							<div class="col">
								<h4 class="mb-1">{{ record.altitude }}ft / {{ (record.altitude * 0.3048).toFixed(0) }}m AGL</h4>
								<div class="small">{{ record.altimeter }}</div>
								<div class="small">{{ record.rocketName }} - {{ record.rocketDiameter }}mm x {{ record.rocketMass }}g</div>
								<div class="small">{{ record.rocketMotors }}</div>
							</div>
						</div>
						<div v-if="showHistory[key] && !hallOfFame.classes[key].history.length">
							<p class="mt-4 mb-0 small">There have been no altitude record attempts for this class.</p>
						</div>
					</div>
					<div class="card-footer">
						<button v-if="!showHistory[key]" @click.prevent="setHistoryForClass(key, true)" :disabled="hallOfFame.classes[key].history.length == 0" class="btn btn-outline-primary btn-sm">Show {{ hallOfFame.classes[key].history.length }} entries <span class="fe fe-chevron-down"></span></button>
						<button v-if="showHistory[key]" @click.prevent="setHistoryForClass(key, false)" class="btn btn-outline-primary btn-sm">Hide extra entries <span class="fe fe-chevron-up"></span></button>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>
